import { render, staticRenderFns } from "./offer-details.vue?vue&type=template&id=6b8a99b7&scoped=true&"
import script from "./offer-details.vue?vue&type=script&lang=js&"
export * from "./offer-details.vue?vue&type=script&lang=js&"
import style0 from "./offer-details.vue?vue&type=style&index=0&id=6b8a99b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a99b7",
  null
  
)

export default component.exports